import React from "react";
import {
  ArrowPosition,
  BadgeColor,
  PopupPosition,
  RelativePopupWrapper,
  StatusChip,
  Tooltip,
  useToggle,
} from "@pushpress/shared-components";

interface AttendeeBadgeColumnProps {
  label: string;
  color: BadgeColor;
  loading?: boolean;
  tooltip: string;
}

function AttendeeBadgeColumn({
  label,
  color,
  loading,
  tooltip,
}: AttendeeBadgeColumnProps) {
  const [tooltipVisible, tooltipActions] = useToggle(false);

  return (
    <RelativePopupWrapper
      popupComponent={
        <Tooltip text={tooltip} arrowPosition={ArrowPosition.Top} />
      }
      popupVisible={tooltipVisible}
      popupPosition={PopupPosition.Bottom_Center}
      setPopupVisibility={tooltipActions.set}
      yOffset={0}
    >
      <div onMouseEnter={tooltipActions.on} onMouseLeave={tooltipActions.off}>
        <StatusChip
          label={label}
          color={color}
          size="small"
          loading={loading}
        />
      </div>
    </RelativePopupWrapper>
  );
}

export default AttendeeBadgeColumn;
